<template>
  <l-cache :get-data="getOrganization" :id="$route.query.id" ref="cache">
    <group-content :group="data" @refresh="$refs.cache.retry()" slot-scope="{data}" :type="type">
      <template slot="title-actions">
        <v-btn @click="" class="mx-0" color="primary" flat>行人通行分组</v-btn>
        <v-btn @click="goToPassGroup" class="mx-0" color="primary" flat v-show="passGroupId!==''">车辆通行分组</v-btn>
      </template>
    </group-content>
  </l-cache>
</template>

<script>
import GroupContent from '../Group/groupContent'

export default {
  name: 'GroupDetails',
  components: {GroupContent},
  data: () => ({
    passGroupId: '',
    type: ''
  }),
  created () {
  },
  methods: {
    async getOrganization () {
      let {items} = await this.$store.dispatch('userAdmin/getGroups', {
        pagination: {page: 1, rowsPerPage: 10},
        filter: [{key: 'id', value: this.$route.query.id}],
      })
      if (items && items.length > 0) {
        let p = items[0]
        console.log(p)
        this.type = items[0].typeList[0].name
        this.passGroupId = ''
        this.findPassGroup(this.$route.query.id)
        return p
      }
      else {
        throw Error('未找到该分组')
      }
    },
    async findPassGroup (id) {
      let res = await this.$store.dispatch('userAdmin/findPassGroup', id)
      console.log(res)
      if (res.data.status === 1) {
        if (res.data.data.content.length !== 0) {
          this.setPassGroupId(res.data.data.content[0].obgrp.id)
        }
      }
      else {
        this.$L.alert('error', {message: '查询通行分组失败,原因：' + res.data.msg})
      }
    },
    setPassGroupId (id) {
      // console.log(id)
      this.passGroupId = id
    },
    goToPassGroup () {
      this.$router.push({
        name: 'passGroupDetails',
        params: {id: this.passGroupId},
        query: {id: this.passGroupId}
      })
    }
  }
}
</script>

<style scoped>

</style>
